'use strict'

export const PLAY_CLASS = 'pause'

export const PAUSE_CLASS = 'play'

export const LOAD_CLASS = 'load'

export const SINGLE = 0

export const ORDER = 1

export const LOOP = 2

export const CIRCULATION = 3

export const RANDOM = 4



// WEBPACK FOOTER //
// ./src/components/constant.js